



















import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import { StepView } from "@share/participants-import/types";
import AdminPanelPager from "@share/common/admin-panel/pager/AdminPanelPager.vue";
import AdminPanel from "@share/common/admin-panel/AdminPanel.vue";

@Component({ components: { AdminPanel, AdminPanelPager } })

export default class TheAdminPanel extends Vue {

    @Prop({ required: true }) currentStep: StepView;
    @Prop({ default: false }) greenDisabled: boolean;
    @Prop({ default: false }) backButtonDisabled: boolean;

    /**
     * handle click on green button of admin panel,
     * it might be next step button or ready button for redirect to participants
     */
    greenButonHandler() {
        if(this.onResult) {
            this.$emit('onReady')
        }
        else {
            this.$emit('next');
        }
    }

    @Watch("isOnEditing")
    isOnEditingWatchHandler(value: boolean) {
        if(!value) {
            this.$emit('onReady')
        }
    }

    get currentPageTitle() {
        switch (this.currentStep) {
            case StepView.upload:
                return this.$t("participants.import.steps.fileUpload");

            case StepView.preview:
                return this.$t("participants.import.steps.preview");

            case StepView.import:
                return this.$t("participants.import.steps.import");

            case StepView.result:
                return this.$t("participants.import.steps.result");

            default:
                break;
        }

        return "unknown";
    }

    /**
     * current step is result
     */
    get onResult() {
        return this.currentStep === StepView.result;
    }

    get stepBackButtonText() {
        return undefined
    }

    get stepUpButonText() {
        return this.onResult ? this.$t('common.ready') : this.$t('common.next');
    }

    get isOnEditing() {
        return this.$store.state.isOnEditing;
    }
}

